<template>
  <div class="sealPositionContainer">
    <div class="mainContainer">
      <div class="content">
        <div class="left fl">
          <div class="title">配置项</div>
          <div class="handwritingCon" id="mySealBox">
            <div class="dropContentBox">
              <img class="normal" src="@image/sealPosition/test_nor_btn.png">
              <img
                class="hover"
                src="@image/sealPosition/test_hov_pre_btn.png"
                alt
                srcset
                data-sealid="1"
                :data-imgsrc="'text'"
                @mousedown="mousedownQR($event)"
                @mouseup="mouseupQR($event,'1')"
                @dragstart="imageDrage($event)"
              >
            </div>
            <div class="dropContentBox">
              <img class="normal" src="@image/sealPosition/qzwz_nor_btn.png">
              <img
                class="hover"
                src="@image/sealPosition/qzwz_hov_pre_btn.png"
                alt
                srcset
                data-sealid="2"
                :data-imgsrc="'seal'"
                @mousedown="mousedownQR($event)"
                @mouseup="mouseupQR($event,'1')"
                @dragstart="imageDrage($event)"
              >
            </div>
          </div>
          <div class="title positionTitle">
            位置详情
            <el-tooltip
              class="item"
              effect="light"
              content="此坐标可用于签约接口签章位置确定"
              placement="right-end"
              popper-class="customerPop"
            >
              <img src="@image/helpCenter/help_icon.png" style="vertical-align:middle">
            </el-tooltip>
          </div>
          <div class="positionContainer">
            <div v-if="currentSealType == 'normalSeal'">
              <span>llx：</span>
              <span>{{llx}}</span>
            </div>
            <div v-if="currentSealType == 'normalSeal'">
              <span>lly：</span>
              <span>{{lly}}</span>
            </div>
            <div v-if="currentSealType == 'normalSeal'">
              <span>rux：</span>
              <span>{{rux}}</span>
            </div>
            <div v-if="currentSealType == 'normalSeal'">
              <span>ruy：</span>
              <span>{{ruy}}</span>
            </div>
            <div v-if="currentSealType == 'qifengSeal'" style="align-items:center;">
              <span>ruy：</span>
              <span>{{ruy}}</span>
            </div>
          </div>
          <div class="copyPosition" @click="copy">点击复制坐标</div>
          <!-- <div class="dropTip">
            <p>
              <span class="waring">注：</span>
              <span>请将文本框/签章拖到右侧文件上，文本</span>
            </p>
            <p>框可经过拖动调整大小。</p>
          </div>-->
        </div>
        <div class="right fl">
          <div class="tabContainerSignC">
            <div class="contractTitle">{{name}}</div>
            <div class="page">
              <div
                data-v-014c3cef
                class="pagingSeal-btn pagingSeal-show"
                v-show="signTypeSingle"
                @click="showQifeng"
              >骑缝签章</div>
              <div
                data-v-014c3cef
                class="pagingSeal-btn pagingSeal-show"
                v-show="!signTypeSingle"
                @click="showSingleSign"
              >单页签章</div>
              <span class="cursorPointer up" @click="toTop('contractId')">
                <img class="nor" src="@image/sign/up_icon_nor.png" alt srcset>
                <img class="hov" src="@image/sign/up_icon_hov_pre.png" alt srcset>
              </span>
              <span class="cursorPointer up" @click="toBottom('contractId')">
                <img class="nor" src="@image/sign/down_icon_nor.png" alt srcset>
                <img class="hov" src="@image/sign/down_icon_hov_pre.png" alt srcset>
              </span>
            </div>
            <div class="pdfCon">
              <div id="contractId"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DargApi from "@lib/dragApi.js";
import browser from "@lib/getBrowser.js";
import BaseApi from "@lib/baseApi.js";
import Util from "@lib/util.js";
import WebSockt from "@lib/webSocket.js";
import { mapState } from "vuex";
import Reg from "@lib/reg.js";
import config from "@lib/config.js";
// Util.getLocationByIp();
let getMouseXY = function(e) {
  return {
    x: e.offsetX,
    y: e.offsetY
  };
};
let dragStart = function(event, element, scrollTop = 0) {
  event.stopPropagation();
  return {
    x: parseInt(getMouseXY(event).x),
    y: parseInt(getMouseXY(event).y)
  };
};
export default {
  components: {},
  computed: {},
  props: ["url", "name"],
  data() {
    return {
      signTypeSingle: true,
      isAddQFSeal: false,
      currentMousePosition: {},
      currentItem: {},
      llx: "",
      lly: "",
      rux: "",
      ruy: "",
      currentSealType: "normalSeal"
    };
  },

  created() {},
  mounted() {
    this.getPdfToImage(this.url, "contractId");
  },
  methods: {
    signConfirm() {
      this.signing = true;
    },
    mousedownQR(e) {
      let scorllTop = (scorllTop = $("#mySealBox").scrollTop());
      this.currentMousePosition = dragStart(
        e,
        $(e.srcElement || e.target).parent()[0],
        scorllTop
      );
    },
    mouseupQR(e, flag) {},
    toTop(id) {
      $(`#${id}`).scrollTop(0);
    },
    toBottom(id) {
      $(`#${id}`).scrollTop($(`#${id}`)[0].scrollHeight);
    },
    imageDrage(e) {
      e.dataTransfer.setData(
        "sealid",
        (e.srcElement || e.target).dataset.sealid
      );
      e.dataTransfer.setData(
        "imgsrc",
        (e.srcElement || e.target).dataset.imgsrc
      );
    },

    getPage(page, index, id) {
      var scale = 1; //缩放倍数，1表示原始大小
      var viewport = page.getViewport(scale);
      var canvas = document.getElementById("canvas" + index + id);
      var canvasFather = canvas.parentNode;
      var context = canvas.getContext("2d");
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      canvasFather.style.width = viewport.width + "px";
      canvasFather.style.height = viewport.height + "px";
      var renderContext = {
        canvasContext: context,
        viewport: viewport
      };
      page.render(renderContext).promise.then(() => {
        this.loadedPageCount++;
      });
    },
    showQifeng() {
      $(".qifenFlag").addClass("qifenDong");
      $(".qifenFlag").addClass("pagingSeal-transition");
      $(".qifengPaddingFlag").removeClass("qifengPadding");
      $(".qifengSeal").removeClass("qifengSealMove");
      this.signTypeSingle = !this.signTypeSingle;
    },
    showSingleSign() {
      $(".qifenFlag").removeClass("qifenDong");
      $(".qifenFlag").removeClass("pagingSeal-transition");
      $(".qifengPaddingFlag").addClass("qifengPadding");
      $(".qifengSeal").addClass("qifengSealMove");
      this.signTypeSingle = !this.signTypeSingle;
    },
    getPdfToImage(url, id) {
      let container = document.getElementById(id);
      container.style.display = "block";
      let _this = this;
      url = url;
      PDFJS.getDocument({ url: url }).then(function getPdfHelloWorld(pdf) {
        _this.totalPage = pdf.numPages;
        for (let i = 1; i <= _this.totalPage; i++) {
          $(container).append(
            `<div class="canvasBoxFlag" data-pageIndex=${i} id="canvasBoxFlag${i}${id}"><canvas data-pageIndex=${i} class="canvasContent" id="canvas${i}${id}"></canvas><p class="pdfPageFlag">${i}/${
              _this.totalPage
            }</p><div class="qifenFlag"></div></div>`
          );
          let obj = $("#canvasBoxFlag" + i + id)[0];
          obj.addEventListener("dragenter", _this.drag, false);
          obj.addEventListener("dragover", _this.drag, false);
          obj.addEventListener("dragleave", _this.drag, false);
          obj.addEventListener("drop", _this.drag, false);
        }
        $(".qifenFlag").on("dragenter", ev => {
          _this.dragQifen(ev.originalEvent);
        });
        $(".qifenFlag").on("dragover", ev => {
          _this.dragQifen(ev.originalEvent);
        });
        $(".qifenFlag").on("dragleave", ev => {
          _this.dragQifen(ev.originalEvent);
        });
        $(".qifenFlag").on("drop", ev => {
          _this.dragQifen(ev.originalEvent);
        });
        $(".canvasBoxFlag").addClass("canvasBox");
        $(".pdfPageFlag").addClass("pdfPage");
        for (let i = 1; i <= _this.totalPage; i++) {
          pdf.getPage(i).then(page => {
            _this.getPage(page, i, id);
          });
        }
      });
    },
    setPostion(prentMent, imgsrc) {
      this.currentSealType = "normalSeal";
      var x = this.currentElement.style.left;
      var y = this.currentElement.style.top;
      console.log(this.currentElement.style);
      x = x.slice(0, x.length - 2) - 0;
      y = y.slice(0, y.length - 2) - 0;

      let canvasheight = prentMent.height();
      if (imgsrc == "text") {
        this.llx = x;
        this.lly = canvasheight - y - 38;
        this.rux = x - 0 + this.currentElement.clientWidth;
        this.ruy = canvasheight - y;
      } else {
        this.llx = x;
        this.lly = canvasheight - y - 119;
        this.rux = x - 0 + 119;
        this.ruy = canvasheight - y;
      }
    },
    setQFPostion(y, sealid, uid, firstCanvasWheight) {
      this.currentSealType = "qifengSeal";
      this.ruy = firstCanvasWheight - y - 110;
    },
    addSeal(element, parentMent, imgsrc, sealid, uid, x, y) {
      this.currentItem.sealPos[sealid] = this.currentItem.sealPos[sealid] || {};
      this.currentElement = element[0];
      this.setPostion(parentMent, imgsrc);
      let dragElement = new DargApi(
        element[0],
        parentMent[0],
        false,
        false,
        (x, y, e) => {
          this.setPostion(parentMent, imgsrc);
        },
        "",
        false,
        e => {
          this.currentElement = e.target || e.srcElement;
        }
      );
      dragElement.create();
      $(parentMent).append(element);
      element.find(".deleteSeal").on("click", e => {
        let el = e.originalEvent.target || e.originalEvent.srcElement;

        let uid = el.dataset.uid;
        let sealid = el.dataset.sealid;
        console.log(sealid);
        delete this.currentItem.sealPos[sealid][uid];
        $(el)
          .parent()
          .remove();
      });
    },
    addQFSeal(e, sealid, imgsrc, uid) {
      let x = e.offsetX || e.layerX;
      let y = e.offsetY || e.layerY;
      let firstCanvasWheight = $($(".canvasBoxFlag")[0])
        .find(".canvasContent")
        .height();
      this.setQFPostion(
        y - this.currentMousePosition.y,
        sealid,
        uid,
        firstCanvasWheight
      );
      Array.prototype.forEach.call($(".canvasBoxFlag"), value => {
        let parentMent = $(value);
        let canvasWidth = parentMent.find(".canvasContent").width();
        let canvasHeight = parentMent.find(".canvasContent").height();
        let element = $(
          `<div class='qifengSeal' data-sealType="qifengSeal" ><div class='qifengPaddingFlag'></div> <div class='deleteSeal' data-uid="${uid}" data-sealid =${sealid}> 删除</div></div>`
        );
        element.append(
          `<div src=${imgsrc} data-uid="${uid}" data-sealid =${sealid} draggable="false"/>签章位置</div>`
        );
        element.addClass("sealNormal");
        element.css({
          top: y - this.currentMousePosition.y,
          left: canvasWidth
        });
        let dragElement = new DargApi(
          element[0],
          parentMent[0],
          true,
          false,
          (x, y) => {
            $(".qifengSeal").css({
              top: y
            });
            this.setQFPostion(y, sealid, uid, firstCanvasWheight);
          }
        );
        dragElement.create();
        parentMent.append(element);
        element.find(".deleteSeal").on("click", e => {
          $(".qifengSeal").remove();
          this.currentItem.isAddQFSeal = false;
        });
      });
    },

    drag(e) {
      // e.preventDefault(); //阻止掉浏览器的默认事件
      e.stopPropagation();
      e.preventDefault();
      switch (e.type) {
        case "dragenter":
          break;
        case "dragover":
          break;
        case "dragleave":
          break;
        case "drop":
          if (this.signTypeSingle) {
            let sealid = e.dataTransfer.getData("sealid");
            let imgsrc = e.dataTransfer.getData("imgsrc");
            let parentMent = $(e.srcElement || e.target).parent();
            // 生成得到页面上的章唯一id
            let uid = Util.getUID();
            let x = e.offsetX || e.layerX;
            let y = e.offsetY || e.layerY;
            if (sealid && imgsrc) {
              let element;
              if (imgsrc == "text") {
                element = $(
                  `<div data-uid="${uid}" data-sealType="normalSeal" data-sealid =${sealid} class="sealNormal sealText">
                      <div class='deleteSeal deleteText' data-uid="${uid}" data-sealid ="${sealid}"> 删除</div>
                  </div>`
                  //
                );
                element.append(
                  ` <div src=${imgsrc} data-uid="${uid}" data-sealid =${sealid} draggable="false"/>这是文本框</div>`
                );
              } else {
                element = $(
                  `<div data-uid="${uid}" data-sealid =${sealid} class="sealNormal"> 
                      <div class='deleteSeal' data-uid="${uid}" data-sealid ="${sealid}"> 删除</div>
                  </div>`
                );
                element.append(
                  ` <div src=${imgsrc} data-uid="${uid}" data-sealid =${sealid} draggable="false"/>签章位置</div>`
                );
              }
              element.css({
                top: y - this.currentMousePosition.y || 0,
                left: x - this.currentMousePosition.x || 0
              });
              this.currentItem.sealPos = this.currentItem.sealPos || {};
              this.addSeal(
                element,
                parentMent,
                imgsrc,
                sealid,
                uid,
                x - this.currentMousePosition.x || 0,
                y - this.currentMousePosition.y || 0
              );
            }
            break;
          }
      }
    },
    copy() {
      var oInput = document.createElement("input");
      if (this.currentSealType == "normalSeal") {
        oInput.value = `{llx:${this.llx},lly:${this.lly},rux:${this.rux},ruy:${
          this.ruy
        }}`;
      } else {
        oInput.value = `{ruy:${this.ruy}}`;
      }

      document.body.appendChild(oInput);
      oInput.select(); //选择对象
      document.execCommand("copy"); //执行浏览器复制命令
      document.body.removeChild(oInput);
    },
    dragQifen(e) {
      e.preventDefault(); //阻止掉浏览器的默认事件
      switch (e.type) {
        case "dragenter":
          break;
        case "dragover":
          break;
        case "dragleave":
          break;
        case "drop":
          let imgsrc = e.dataTransfer.getData("imgsrc");
          if (imgsrc !== "text") {
            let sealid = e.dataTransfer.getData("sealid");

            let uid = Util.getUID();
            if (!this.currentItem.isAddQFSeal) {
              this.currentItem.isAddQFSeal = true;
              if (sealid) {
                this.addQFSeal(e, sealid, imgsrc, uid);
              }
            } else {
              this.$message.error("骑缝章只能上传一个");
            }
            break;
          }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.canvasBox {
  position: relative;
}
.customerPop {
  width: 160px;
  height: 50px;
  line-height: 20px;
  box-sizing: border-box;
  padding: 0 10px;
  background-color: white;
  color: #646464;
  padding: 5px;
}
.is-light {
  border: 1px solid rgb(152, 152, 152) !important;
}
.pagingSeal-btn {
  cursor: pointer;
  width: 32px;
  padding: 15px 0;
  text-align: center;
  line-height: 32px;
  letter-spacing: 3px;
  font-size: 16px;
  writing-mode: vertical-rl;
  border-radius: 0 15px 15px 0;
  transition: all 0.3s;
  background: #4a90e2;
  border-radius: 15px;
  color: #fff;
  margin-left: 13px;
}
.sealNormal {
  position: absolute;
  width: 119px;
  height: 119px;
  touch-action: none;
  background-color: rgba(208, 2, 27, 0.08);
  z-index: 4;
  line-height: 119px;
  text-align: center;
  color: #e0adb1;
  cursor: move;
  img {
    width: 119px;
    height: 119px;
  }
  .deleteSeal {
    position: absolute;
    display: none;
    font-size: 12px;
    font-weight: 400;
    color: #fff;
    line-height: 12px;
    text-align: center;
    width: 40px;
    height: 20px;
    z-index: 2;
    line-height: 20px;
    background: rgba(208, 2, 27, 0.6);
    opacity: 1;
    border-radius: 0 0 10px 10px;
    cursor: pointer;
    border: none;
    left: 50%;
    top: 118px;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
  }
  .deleteText {
    top: 38px;
  }
  &:hover {
    .deleteSeal {
      display: block;
    }
  }
}
.sealText {
  width: 180px;
  height: 38px;
  line-height: 38px;
  font-size: 18px;
  color: #e0adb1;
  text-align: center;
}

.pdfPage {
  position: absolute;
  top: 24px;
  right: 24px;
  padding: 3px 16px;
  font-size: 18px;
  font-weight: 200;
  color: #fff;
  line-height: 25px;
  border-radius: 8px;
  background: #9b9b9b;
}
.qifenDong {
  position: absolute;
  top: 0;
  right: -1px;
  width: 120px;
  height: 100%;
  border-radius: 0 14px 14px 0;
  background: #fff;
  z-index: 2;
  transition: all 0.3s;
  background: url(../../../assets/images/personalSign/qifengSealBg.png)
    no-repeat 100%;
  background-size: 100% 100%;
}
.pagingSeal-transition {
  transform: translateX(120px);
}
.sealFlagQifeng {
}
.qifengSealMove {
  transform: translateX(-23px);
  &:hover {
    .deleteSeal {
      display: none;
    }
  }
}
.qifengPadding {
  position: absolute;
  top: 0;
  left: 30px;
  z-index: 3;
  width: 89px;
  height: 119px;
  -webkit-transition: width 0.3s;
  transition: width 0.3s;
  background: #e4e9ee;
}
.signing {
  .input {
    display: inline-block;
    width: 160px;
    height: 30px;
    .el-input__inner {
      height: 100%;
      line-height: 30px;
      border-radius: 0px;
    }
  }
}
</style>

<style lang="scss">
.handwritingCon {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 40px;
  .dropContentBox {
    .hover {
      display: none;
    }
    .normal {
      display: block;
    }
    &:hover {
      .hover {
        display: block;
      }
      .normal {
        display: none;
      }
    }
  }
}
.positionContainer {
  display: flex;
  width: 240px;
  height: 114px;
  background: #fafafa;
  justify-content: space-around;
  align-content: space-around;
  flex-wrap: wrap;
  margin-top: 10px;
  & > div {
    width: 50%;
    display: flex;
    justify-content: center;
    font-size: 12px;
    color: #969696;
    letter-spacing: 0;
    line-height: 12px;
    & > span:first-child {
      margin-right: 10px;
    }
  }
}
.copyPosition {
  background: #fcfcfc;
  border: 1px solid #db4437;
  cursor: pointer;
  margin-top: 20px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  font-size: 12px;
  color: #db4437;
}
.dropTip {
  padding-top: 20px;
  border-top: 1px solid #e4e8eb;
  margin-top: 175px;
  font-size: 12px;
  color: #000000;
  line-height: 12px;
  & > p {
    margin-bottom: 10px;
  }
  & > p:last-child {
    text-indent: 2em;
  }
  .waring {
    color: #db4437;
  }
}
.handwritingModal {
  width: 500px;
  height: 410px;
  .scanning {
    color: #646464;
    text-align: center;
    margin-top: 18px;
  }
  .effective {
    color: #4daff7;
    text-align: center;
    margin-top: 30px;
    margin-bottom: 10px;
  }
  #canvas {
    margin: 0 auto;
    width: 200px !important;
    height: 200px !important;
    display: block;
    padding-left: 46px;
  }
  .warning {
    margin-top: 40px;
    padding: 0 40px;
    text-align: justify;
    line-height: 20px;
    color: #000;
    i {
      font-style: normal;
      color: #e88078;
    }
  }
}
.sealPositionContainer {
  .forgetPassword {
    width: 450px;
    height: 290px;
    .content {
      width: 450px;
      height: 220px;
      overflow: hidden;
      padding-top: 30px;
      .leftPass {
        width: 160px;
        height: 220px;
        span {
          i {
            color: #db4437;
          }
          display: block;
          text-align: right;
          height: 50px;
          line-height: 30px;
        }
      }
      .rightPass {
        width: 290px;
        height: 220px;
        .passwordInput {
          height: 50px;
          .getCode {
            color: #70c8e5;
            margin-left: 6px;
          }
          .errorMessage {
            color: #db4437;
          }
        }
        .input {
          width: 200px;
          height: 30px;
        }
      }
    }
    .foot {
      text-align: center;
      .can {
        width: 100px;
        height: 32px;
      }
    }
  }
  .cancel {
    margin-top: 54px;
    padding-bottom: 30px;
    text-align: center;
    .can {
      width: 100px;
      height: 32px;
    }
    .sure {
      width: 100px;
      height: 32px;
    }
  }
  .password {
    text-align: center;
    padding-left: 18px;
    margin-top: 54px;
    color: #919191;
    .el-form-item__content {
      text-align: left;
    }
    .forget {
      margin-left: 6px;
      text-decoration: none;
      border-bottom: 1px solid #ccc;
      display: inline-block;
      padding-bottom: 1px;
      line-height: 20px;
      cursor: pointer;
    }
  }
  .mainContainer {
    height: calc(100% - 40px);
    .header {
      width: 100%;
      height: 36px;
      line-height: 36px;
      border-bottom: 1px solid #e4e8eb;
      span {
        display: inline-block;
        color: #787878;
      }
      span:nth-of-type(2) {
        margin-left: 20px;
      }
      span:nth-of-type(4) {
        color: #e88078;
      }
      .leftBar {
        width: 4px;
        height: 20px;
        background: #e88078;
        border-radius: 4px;
        position: relative;
        top: 3px;
      }
    }
    .footer {
      width: 100%;
      height: 72px;
      padding-top: 26px;
      text-align: right;
      .ret {
        width: 100px;
        height: 32px;
      }
    }
    .content {
      width: 100%;
      overflow: hidden;
      height: calc(100% - 128px);
      margin-top: 20px;
      .left {
        box-sizing: border-box;
        width: 280px;
        height: 602px;
        border: 1px solid #e4e8eb;
        padding: 20px;
        .title {
          line-height: 32px;
          font-size: 14px;
          color: #646464;
          border-bottom: 1px solid #ebebeb;
        }
      }
      .right {
        float: right;
        width: 890px;
        height: 602px;
        margin-left: 10px;
        border: 1px solid #e4e8eb;
      }
    }
  }
}
.tabContainerSignC {
  height: 100%;
  background: #e3e9ef;
  box-sizing: border-box;
  position: relative;
  .contractTitle {
    height: 22px;
    line-height: 22px;
    background-color: white;
    color: #db4437;
    text-align: center;
    font-size: 12px;
  }
  .moreSign {
    &:hover {
      .allSignContainer {
        display: block;
      }
    }
  }
  .allSignContainer {
    display: none;
    position: absolute;
    top: 33px;
    z-index: 10;
    width: 100%;
    .allSign {
      opacity: 0.8;
      background: #ffffff;
      border: 1px solid #e4e8eb;
      padding-top: 10px;
      .allSignItem {
        display: inline-block;
        cursor: pointer;
        width: 132px;
        font-size: 12px;
        line-height: 32px;
        padding: 0 20px;
        &:hover {
          color: #e88078;
        }
      }
    }
  }
  .selectMore {
    position: absolute;
    cursor: pointer;
    width: 100px;
    height: 30px;
    line-height: 32px;
    right: 0;
    top: 0;
    border: 1px solid #e29999;
    font-size: 12px;
    color: #e29999;
    text-align: center;
    z-index: 2;
  }
  .el-tabs__header {
    max-width: calc(100% - 120px);
  }
  .el-tabs__nav-next,
  .el-tabs__nav-prev {
    line-height: 33px;
  }
  .el-tabs {
    height: 100%;
  }
  .el-tabs__item {
    height: 33px;
    line-height: 30px;
    font-size: 12px;
    color: #646464;
    background: #f5f5f5;
    border-top: 3px solid #f5f5f5;
  }
  .el-tabs__header {
    margin-bottom: 0;
  }
  .el-tabs__item:hover {
    color: #e88078;
  }
  .el-tabs--card > .el-tabs__header {
    border-bottom: 1px solid #e4e8eb;
  }
  .el-tabs__item.is-active {
    color: #e88078;
    background-color: #ffffff;
    border-top: 3px solid #e88078;
  }
  .flowContainer {
    height: 100%;
    box-sizing: border-box;
    padding-top: 50px;
  }
  .performContainer {
    height: 100%;
    box-sizing: border-box;
    padding-bottom: 20px;
    padding-top: 10px;
    overflow-y: auto;
  }
  .page {
    position: absolute;
    right: 10px;
    width: 60px;
    height: 190px;
    text-align: center;
    bottom: 30px;
    z-index: 20;
    span {
      margin-top: 6px;
      display: block;
    }
    .up {
      img {
        margin: 0 auto;
      }
      .nor {
        display: block;
      }
      .hov {
        display: none;
      }
      &:hover {
        .nor {
          display: none;
        }
        .hov {
          display: block;
        }
      }
    }
  }
  .pdfCon {
    box-sizing: border-box;
    height: calc(100% - 22px);
    padding-left: 63px;
    padding-top: 30px;
    padding-bottom: 30px;

    & > div {
      height: 100%;
      overflow: auto;
    }
  }
}
</style>
